/* Compact store-wide reviews and an unobtrusive help launcher. No app account changes. */
(function(){
  function reviews(root){
    if(root.dataset.compactReady)return;root.dataset.compactReady='true';
    var expanded=false, scheduled=false;
    var button=document.createElement('button');button.type='button';button.className='spqr-review-expand';button.hidden=true;
    button.setAttribute('aria-controls','judgeme_all_reviews_page');
    root.appendChild(button);
    function update(){
      scheduled=false;var body=root.querySelector('.jdgm-all-reviews__body');if(!body)return;
      var cards=Array.from(body.children).filter(function(el){return el.classList.contains('jdgm-rev');});
      root.dataset.reviewExpanded=String(expanded);
      cards.forEach(function(el,i){el.classList.toggle('spqr-review-collapsed',!expanded && i>=3);});
      button.hidden=cards.length<=3;button.setAttribute('aria-expanded',String(expanded));
      var label=expanded?'Show fewer reviews':'Show more reviews';if(button.textContent!==label)button.textContent=label;
    }
    function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(update);}
    button.addEventListener('click',function(){expanded=!expanded;update();if(!expanded)root.scrollIntoView({block:'start'});});
    root.addEventListener('change',function(event){if(event.target.matches('select')){expanded=true;schedule();}});
    root.addEventListener('click',function(event){if(event.target.closest('.jdgm-histogram__row,.jdgm-subtab,.jdgm-paginate__load-more')){expanded=true;schedule();}});
    new MutationObserver(schedule).observe(root,{childList:true,subtree:true});update();
  }
  function chat(){
    var host=document.querySelector('shopify-chat'),shadow=host && host.shadowRoot;
    if(!shadow || shadow.querySelector('[data-spqr-chat-style]'))return;
    var style=document.createElement('style');style.dataset.spqrChatStyle='true';
    style.textContent='@media(max-width:768px){.activator-nudge{position:fixed!important;right:12px!important;bottom:calc(90px + env(safe-area-inset-bottom))!important}.activator{width:44px!important;min-width:44px!important;height:44px!important;padding:10px!important;justify-content:center!important}.activator__label{display:none!important}}';
    shadow.appendChild(style);
  }
  function boot(){document.querySelectorAll('#spqr-store-reviews').forEach(reviews);chat();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
  // Shopify mounts the chat element after its app bundle loads.
  var observer=new MutationObserver(function(){chat();if(document.querySelector('shopify-chat')?.shadowRoot?.querySelector('[data-spqr-chat-style]'))observer.disconnect();});
  observer.observe(document.documentElement,{childList:true,subtree:true});
  customElements.whenDefined('shopify-chat').then(chat);
})();
